module.exports = __webpack_public_path__ + "img/shape7.88280cbf.png";